var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08267 15.8335C3.99924 15.7269 3.18762 15.4015 2.6433 14.8572C1.66699 13.8809 1.66699 12.3095 1.66699 9.16683V8.75016C1.66699 5.60746 1.66699 4.03612 2.6433 3.0598C3.61962 2.0835 5.19096 2.0835 8.33366 2.0835H11.667C14.8097 2.0835 16.3811 2.0835 17.3573 3.0598C18.3337 4.03612 18.3337 5.60746 18.3337 8.75016V9.16683C18.3337 12.3095 18.3337 13.8809 17.3573 14.8572C16.3811 15.8335 14.8097 15.8335 11.667 15.8335C11.1999 15.8439 10.8279 15.8794 10.4625 15.9627C9.46383 16.1926 8.53908 16.7036 7.62522 17.1492C6.32307 17.7842 5.67199 18.1017 5.2634 17.8044C4.48173 17.2222 5.24578 15.4184 5.41699 14.5835",
    stroke: "#C60FEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 11.2502H13.3337M6.66699 7.0835H10.0003",
    stroke: "#C60FEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/MessageSquare.2238530327be8b0b751489c33f6b3a4e.svg";
export { ForwardRef as ReactComponent };